import { FC } from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

export const MarktkapitalisierungChart: FC = () => {
  const chartData = {
    series: [0, 8, 92],
    options: {
      labels: ['Small Cap', 'Mid Cap', 'Large Cap'],
      colors: ['#0461B8', '#275681', '#4A4A4A'],
      chart: {
        type: 'donut',
      },
      legend: {
        show: true,
        position: 'right',
        containerMargin: {
          top: 0,
        },
        fontSize: '16px',
        fontFamily: 'Fira Sans',
      },
      responsive: [
        {
          breakpoint: 600,
          options: {
            legend: {
              fontSize: '11px',
              position: 'bottom',
              width: '100%',
            },
          },
        },
      ],
    },
  };

  return (
    <div className="pie-chart-wrapper">
      <ReactApexChart options={chartData.options as ApexOptions} series={chartData.series} type="donut" />
    </div>
  );
};
